import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Store from '../store/index';
import Layout from '@/views/Layout/index.vue';

Vue.use(VueRouter);

const appRoutes = [
  // 受注入力_公開用
  {
    path: 'g-juchu-entry',
    name: 'G_020',
    component: () => import('../views/G_kaigai/G_020_JuchuEntry.vue'),
  },
  // 受注問合せ_公開用
  {
    path: 'g-juchu-list',
    name: 'G_030',
    component: () => import('../views/G_kaigai/G_030_JuchuToiawase.vue'),
  },
  // 発注確認_公開用
  {
    path: 'g-hatchu-confirm',
    name: 'G_040',
    component: () => import('../views/G_kaigai/G_040_HatchuConfirm.vue'),
  },
  // 発送案内入力_公開用
  {
    path: 'g-hasso-annai-entry',
    name: 'G_050',
    component: () => import('../views/G_kaigai/G_050_HassoAnnaiEntry.vue'),
  },
  // 出荷準備_公開用
  {
    path: 'g-shukka-junbi',
    name: 'G_060',
    component: () => import('../views/G_kaigai/G_060_ShukkaJunbi.vue'),
  },
  // 販売予測確認_公開用
  {
    path: 'g-hambai-yosoku-confirm',
    name: 'G_070',
    component: () => import('../views/G_kaigai/G_070_HambaiYosokuConfirm.vue'),
  },
  // 工場出来高入力_公開用
  {
    path: 'g-kojo-dekidaka-entry',
    name: 'G_080',
    component: () => import('../views/G_kaigai/G_080_KojoDekidakaEntry.vue'),
  },
  // 在庫移動依頼入力_公開用
  {
    path: 'g-zaiko-ido-irai-entry',
    name: 'G_090',
    component: () => import('../views/G_kaigai/G_090_ZaikoIdoIraiEntry.vue'),
  },
  // // 加工振替入力_公開用
  // {
  //   path: 'g-kako-furikae-entry',
  //   name: 'G_100',
  //   component: () => import('../views/G_kaigai/G_100_KakoFurikaeEntry.vue'),
  // },
  // 請求一覧_公開用
  {
    path: 'g-seikyu-list',
    name: 'G_110',
    component: () => import('../views/G_kaigai/G_110_SeikyuList.vue'),
  },
  // ホーム画面（会外）
  {
    path: 'home',
    name: 'G_120',
    component: () => import('../views/G_kaigai/G_120_Home.vue'),
  },
  // 納品先マスタ照会_公開用
  {
    path: 'g-nohinsaki-mst-mente',
    name: 'G_130',
    component: () => import('../views/G_kaigai/G_130_NohinsakiMstMente.vue'),
  },
  // 出庫・配送依頼確認_公開用
  {
    path: 'g-haiso-Irai',
    name: 'G_140',
    component: () => import('../views/G_kaigai/G_140_HaisoIrai.vue'),
  },
  {
    path: 'system-error',
    name: 'SystemError',
    component: () => import('../views/Layout/error.vue'),
  },
  // 配送会社マスタ照会_公開用
  {
    path: 'g-haiso-mst-mente',
    name: 'G_150',
    component: () => import('../views/G_kaigai/G_150_HaisoMstMente.vue'),
  },
  // 出庫・配送依頼確認_公開用
  {
    path: 'g-haiso-Irai-Logi',
    name: 'G_160',
    component: () => import('../views/G_kaigai/G_160_HaisoIraiLogi.vue'),
  },
];

// サンプル用ルート（不要になったら削除）
const sampleRoutes = [
  {
    path: 'test',
    name: 'Test',
    component: () => import('../views/sample/Test.vue'),
  },
  {
    path: 'test2',
    name: 'Test2',
    component: () => import('../views/sample/Test2.vue'),
  },
  {
    path: 'pdf-test',
    name: 'PdfTest',
    component: () => import('../views/sample/PdfTest.vue'),
  },
];

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: appRoutes.concat(sampleRoutes),
  },
  {
    path: '/login',
    name: 'Login',
    meta: { isPublic: true },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: { isPublic: true },
    component: () => import('../views/ForgotPassword.vue'),
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue'),
  },
  {
    path: '/location',
    name: 'Location',
    component: () => import('../views/Layout/Location.vue'),
  },
  {
    path: '*',
    name: 'not-found',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const ProgramId = to.name as string;
  sessionStorage.setItem('ProgramId', ProgramId);
  // そのままではunknown型になるためanyに代入
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const authState: any = Store.state;
  // isPublic でない場合(=認証が必要な場合)、かつ、ログインしていない場合
  if (
    to.matched.some((record) => !record.meta.isPublic) &&
    !authState.common.auth
  ) {
    next('/login');
  } else {
    next();
  }
});

export default router;
